export default {
  SET_DATA: 'SET_DATA',
  UPDATE: 'UPDATE'
};
